import React from 'react';
import PropTypes from 'prop-types';

const MobileInfoBlock = props => {
  return (
    <>
      <div className="is-flex align-items-center mt-25px">
        <img src={props.iconPath} width={35} height={35} />
        <p className="m-info-title ml-10px">{props.title}</p>
      </div>
      <p className="m-container-text mt-10px">{props.text}</p>
    </>
  );
};

MobileInfoBlock.propTypes = {
  iconPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default MobileInfoBlock;
